<template>
  <div>
    <div v-if="store.user.profile.gAuthenticatorEnabled">
      <div class="main-content f-left">
        <Form @submit="submit">
          <div class="row-sec">
            <div class="form-holder">
              <ul>
                <li>
                  <label class="white t-center" for="">{{$t("success_box.otp_varify")}}</label>
                  <Field
                    autocomplete="off"
                    name="google token"
                    v-model="this.$parent.google_token"
                    rules="required|min:6|max:6|numeric"
                  />
                  <ErrorMessage name="google token" />
                </li>
              </ul>
            </div>
          </div>
          <div class="btn-holder t-center">
            <button type="button" @click="resetAndBack" class="btn btn-blue popup-link-holder">
              {{$t("success_box.cancel")}}
            </button>
            <button type="submit" class="btn btn-yellow popup-link-holder">
              {{$t("success_box.submit")}}
            </button>
          </div>
        </Form>
        <p class="t-center">{{$t("success_box.trouble_with_2fa")}}
          <a @click="sendEmail">{{$t("success_box.click_varify_with_email")}}</a>
        </p>
      </div>
    </div>
    <div class="t-center" v-else>
      <!-- <h4>
        Verification email has been sent to your registered email. Please click
        on that link to verify your request
      </h4> -->
      <p>{{$t("success_box.or")}}</p>
      <p>
        <router-link class="white underline" :to="`/security?type=${type}&id=${store.trans_id}`">{{$t("success_box.click_here")}}</router-link>
        {{$t("success_box.to_enable_2fa")}}
      </p>
      <div class="btn-holder t-center">
        <button type="button" @click="resetAndBack" class="btn btn-yellow popup-link-holder">
          {{$t("success_box.take_me_back")}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  props: ["type"],
  setup() {
    const store = useMainStore();
    return { store };
  },
  components: { Form, Field, ErrorMessage },
  methods: {
    submit() {
      this.$parent.verify();
    },
    sendEmail() {
      this.$parent.resend();
    },
    resetAndBack() {
      this.store.$patch({ trans_id: null });
      this.$router.back();
    },
  },
};
</script>
